import { queryBot2 } from 'boot/axios';

export async function removeUsersByProjectIdWithoutAuthor (projectId) {
    await queryBot2('removeUsersWithoutAuthor', { projectId }).then((r) => {
        console.log('del >', r);
    });
}

export async function removeUsersByProjectId (projectId) {
    await queryBot2('removeUsersByProjectId', { projectId }).then((r) => {
        console.log('del >', r);
    });
}

export async function removeUserById (userId) {
    await queryBot2('removeUserById', { userId }).then((r) => {
        console.log('del >', r, userId);
    });
}

export default removeUserById;
